import { createErrorResult, isError, isException } from '../resultful';
import * as ErrorTypes from './error-types';
import * as UIAssociations from './error-ui-associations';
export { ErrorTypes, UIAssociations };
// TODO: Standarize naming
var createCreditCardStripe = function createCreditCardStripe(stripeError, association) {
  return createErrorResult({
    type: ErrorTypes.STRIPE_ERROR,
    stripeError: stripeError,
    association: association
  });
};
export var createGenericCreditCardStripeError = function createGenericCreditCardStripeError(stripeError) {
  return createCreditCardStripe(stripeError, {
    type: UIAssociations.BindingLevels.NONE
  });
};
export var createFieldCreditCardStripeError = function createFieldCreditCardStripeError(stripeError, fieldName) {
  return createCreditCardStripe(stripeError, {
    type: UIAssociations.BindingLevels.INPUT,
    name: fieldName
  });
};
export var createCreditCardCustomError = function createCreditCardCustomError(message, association, userFriendlyMessage) {
  return createErrorResult({
    type: ErrorTypes.COMMERCE_CREDIT_CARD_ERROR,
    message: message,
    association: association,
    userFriendlyMessage: userFriendlyMessage
  });
};
export var createFieldCustomValidationError = function createFieldCustomValidationError(message, fieldName, userFriendlyMessage) {
  return createCreditCardCustomError(message, {
    type: UIAssociations.BindingLevels.INPUT,
    name: fieldName
  }, userFriendlyMessage);
};
/**
 * Useful if you want to figure out if a error is worth logging (say, to Sentry)
 * @returns
 * true if the user was the one who caused the error in the first place. E.g. They used an invalid card/validation error
 * false if it's something in our code or service communication, etc has caused it.
 */
export var isSystemErrorResult = function isSystemErrorResult(result) {
  if (!isError(result)) {
    return false;
  }
  switch (result.error.type) {
    case ErrorTypes.COMMERCE_CREDIT_CARD_ERROR:
      return false;
    case ErrorTypes.STRIPE_ERROR:
      switch (result.error.stripeError.type) {
        case 'card_error':
        case 'validation_error':
        case 'api_connection_error':
          // Happens, primarily, when you have a bad internet connection
          return false;
        case 'invalid_request_error':
          switch (result.error.stripeError.code) {
            case 'payment_intent_authentication_failure':
            case 'setup_intent_authentication_failure':
              // These errors are initiated by the user
              return false;
            default:
              return true;
          }
        default:
          return true;
      }
    default:
      return true;
  }
};
export var getUserFriendlyFailureMessage = function getUserFriendlyFailureMessage(result) {
  if (isException(result)) {
    return undefined;
  }
  var error = result.error;
  switch (error.type) {
    case ErrorTypes.COMMERCE_CREDIT_CARD_ERROR:
      return error.userFriendlyMessage;
    case ErrorTypes.STRIPE_ERROR:
      if (isSystemErrorResult(result)) {
        // We're assuming Stripe won't have user friendly messages for system errors
        return undefined;
      }
      return error.stripeError.message;
  }
};

/**
 * @returns true if the error is a 3DS failure (both caused by either the system/internals or user)
 */
export var isPaymentAuthenticationFailureResult = function isPaymentAuthenticationFailureResult(result) {
  if (!isError(result)) {
    return false;
  }
  var error = result.error;
  if (error.type !== ErrorTypes.STRIPE_ERROR) {
    return false;
  }
  var stripeError = error.stripeError;
  if (stripeError.code === undefined) {
    return false;
  }
  return ['authentication_required', 'payment_intent_authentication_failure', 'setup_intent_authentication_failure'].includes(stripeError.code);
};